import * as React from 'react';
import { ArticleHeading1, ITypographyComponentProps, TDeviceType, TMemoForwardRefComponent } from '@cian/ui-kit';
import { clsx } from 'clsx';

import { FREEDOME_ROUTINE } from '../../constants/freedomRoutine';

import * as style from './styles.css';

interface IFreedomRoutineProps {
  device: TDeviceType;
  ItemTitle: TMemoForwardRefComponent<ITypographyComponentProps, HTMLElement>;
  Description: TMemoForwardRefComponent<ITypographyComponentProps, HTMLElement>;
}

export const FreedomRoutine: React.FC<IFreedomRoutineProps> = ({ device, ItemTitle, Description }) => {
  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['title']}>
        <ArticleHeading1 textAlign={device === 'phone' ? 'left' : 'center'}>
          Свобода от рутины и контроль за сделкой через личный кабинет
        </ArticleHeading1>
      </div>
      <div className={style['list']}>
        {FREEDOME_ROUTINE.map(({ id, title, descr, imageClass }) => (
          <div className={style['item']} key={id}>
            <div className={style['textblock']}>
              <div className={style['title']}>
                <ItemTitle>{title}</ItemTitle>
              </div>
              <div className={style['descr']}>
                <Description>{descr}</Description>
              </div>
            </div>
            <div className={clsx(style['image'], style[imageClass])} />
          </div>
        ))}
      </div>
      <div className={style['notice']}>Вы занимаетесь продажами, мы заботимся о&nbsp;сделке</div>
    </div>
  );
};
